import {Button} from 'antd';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {useNavigate} from 'react-router-dom';

import {RQUserRegistrationAPI} from '../../../reactQuery/apis';

import {RegistrationForm} from './RegistrationForm';

const RegistrationScreen = ({setShowRegister}) => {
  const navigate = useNavigate();

  const {mutateAsync: registerUser, isLoading} = RQUserRegistrationAPI();

  const onSubmit = async values => {
    try {
      const res = await registerUser(values);

      if (res?.success !== false) {
        toast.success('Registered successfully!');
        navigate('/auth/login');
        setShowRegister(false);
      } else {
        toast.error(res?.message || 'Registration failed');
      }
    } catch (error) {
      toast.error(error?.response.data.message|| 'Registration failed');
    }
  };

  return (
    <div className={'flex justify-center items-center h-full'}>
      <div className={'w-full lg:p-4'}>
        <RegistrationForm
          onSubmit={onSubmit}
          isLoading={isLoading}
        />

        <Button
          type={'link'}
          className={'w-full !text-primary-900'}
          onClick={() => setShowRegister(false)}
        >
          Already have an account? Login
        </Button>
      </div>
    </div>
  );
};

RegistrationScreen.propTypes = {
  setShowRegister: PropTypes.func.isRequired,
};

export default RegistrationScreen;
